// extracted by mini-css-extract-plugin
module.exports = {"bb-text":"bb-text___aVjF","bb-text-large":"bb-text-large__I9il3"};